import WorkspaceLayout from '../../components/navigation/WorkspaceLayout'

export default function PatientLayout() {
  return <WorkspaceLayout role="patient" />
}
